import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import './reports.css';
import Header from '../common/Header';
import { COMMON, REPORTS_SCREEN, ALL_ROUTES } from '../../global/Constants';
import DesktopFooter from '../common/DesktopFooter';
import ApiServices from '../../providers/ApiServices';
import Utilities from '../../global/Utilities';
import Select from 'react-select';
import moment from 'moment';
import Loader from '../common/loader/Loader';
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import { HeaderTypes, ReportType } from '../../global/Enum';
import SyncLoader from '../common/loader/SyncLoader';
import AuthService from '../../providers/AuthService';
require('datatables.net');


class KrishakReport extends Component {

    constructor(props) {
        super(props)
        this.datatable = null;

        this.state = {
            type1: 'text',
            type2: 'text',
            allPrerakData: [
                { value: 2, label: "Krishak" },
                { value: 1, label: "Prerak" },
                { value: 0, label: "All" }
            ],
            allCropGroupData: [],
            allCropData: [],
            allStatesData: [],
            allDistrictsData: [],
            allTehsilsData: [],
            allVillagesData: [],
            selectedState: null,
            selectedPrerak: null,
            selectedDistrict: null,
            selectedTehsil: null,
            selectedVillage: null,
            selectedCropGroup: null,
            selectedCrop: null,
            isLoading: false,
            fields: {
                fromDate: "",
                toDate: "",
                mobile: ""
            },
            regexp: /^[0-9\b]+$/
        }
    }

    componentDidMount() {
        const session = AuthService.getSession();

        if (session) {
            this.getAllStates();
            this.getAllCropGroup();
            this.initializeDataTable();
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    initializeDataTable() {

        this.$el = $(this.el);
        this.dataTable = this.$el.DataTable({
            columns: [
                { title: 'From Date' },
                { title: 'To Date' },
                { title: 'Message' },
                { title: 'Status' }
            ],
            rowCallback: function (row, data) {
                $(row).css("font-size", "16px");
            },
        });


        this.getReports();

        return () => {
            this.dataTable.destroy(true);
        };
    }

    getReports() {
        this.setState({ isLoading: true });

        var body = JSON.stringify({
            type: ReportType.EXPORT_KRISHAK_REPORT
        });
        try {
            ApiServices.getReport(body).then(response => {
                var status = response.success;
                Utilities.LogPrint("getUserReports ===>", response);
                this.setState({ isLoading: false });
                if (status) {
                    const newArrayOfObj = response.data;
                    let tempMainArray = [];
                    for (var i = 0; i < newArrayOfObj.length; i++) {
                        const obj = newArrayOfObj[i];
                        let tempArray = [];

                        const request = JSON.parse(obj.request);
                        const fromDate = moment(request.from_date).format("DD-MM-YYYY");
                        const toDate = moment(request.to_date).format("DD-MM-YYYY");

                        tempArray.push(fromDate);
                        tempArray.push(toDate);
                        tempArray.push(obj.message);
                        //tempArray.push(obj.status);

                        let status = '';
                        if (obj?.download_url === null) {
                            status = `<b style="color: orange;" }}>${obj.status}</b>`;
                        } else {
                            status = `<u class="status" style="cursor: pointer;  color: green;" }}>${obj.status}</u>`;
                            //status = `${Utilities.getDownloadButton(obj.status)}`;
                        }

                        tempArray.push(status);
                        tempArray.push(obj.download_url);

                        tempMainArray.push(tempArray);
                    }
                    this.dataTable.clear();
                    this.dataTable.rows.add(tempMainArray);
                    this.dataTable.draw();
                    Utilities.LogPrint("userReport", newArrayOfObj);

                    // Wait for the DataTable to render before setting up the click event
                    setTimeout(() => {
                        $(this.dataTable.table().body()).on('click', '.status', (event) => {
                            const clickedRow = this.dataTable.row($(event.currentTarget).closest('tr'));

                            // Get the data from the clicked row
                            const rowData = clickedRow.data();
                            const downloadUrl = rowData['4'];
                            Utilities.LogPrint("downloadUrl ===>", downloadUrl);
                            if (downloadUrl !== null) {
                                window.open(downloadUrl, '_blank');
                            }
                        });
                    }, 0);
                } else {
                    Utilities.LogPrint("userReport", response);
                    if (response.message === COMMON.TOKEN_EXPIRED) {
                        Utilities.tokenExpiredRedirectToLogin();
                    }
                }

            }).catch(error => {
                this.setState({ isLoading: false });
                Utilities.LogPrint("userReport", error);
            });
        } catch (error) {
            this.setState({ isLoading: false });
            Utilities.LogPrint("userReport", error);
        }
    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || typeof value === "undefined") {
            value = defaultValue;
        }
        return value;
    }

    _handleValueChange = (field, e) => {
        if (field === "mobile") {
            let telephone = e.target.value;
            if (telephone === '' || this.state.regexp.test(telephone)) {
                let fields = this.state.fields;
                fields[field] = telephone;
                this.setState({ fields });
            }
        } else {
            let fields = this.state.fields;
            fields[field] = e.target.value;
            this.setState({ fields });
        }
    };

    getAllActiveCrop = (id) => {
        this.setState({ allCropData: [], selectedCrop: null });
        let params = JSON.stringify({
            crop_group_id: id
        })
        try {
            ApiServices.getUserCrop(params)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allCropData: data.map(({ crop_id: value, crop_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    getAllCropGroup = () => {
        try {
            ApiServices.getUserCropGroup("")
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allCropGroupData: data.map(({ crop_group_id: value, crop_group_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    getAllStates = () => {
        try {
            ApiServices.getUserState("")
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allStatesData: data.map(({ state_id: value, state_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    getAllDistricts = (selectedState) => {
        let request = JSON.stringify({
            state_id: selectedState.value
        })

        try {
            ApiServices.getAllActiveDistrict(request)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allDistrictsData: data.map(({ district_id: value, district_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    getAllTehsils = (selectedDistrict) => {
        let request = JSON.stringify({
            district_id: selectedDistrict.value
        })
        try {
            ApiServices.getActiveTehsilByDistrictId(request)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allTehsilsData: data.map(({ tehsil_id: value, tehsil_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    getAllVillageById = (selectedTehsil) => {
        let request = JSON.stringify({
            tehsil_id: selectedTehsil.value
        })
        try {
            ApiServices.getAllVillageByUser(request)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allVillagesData: data.map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    handleStateChange = selectedState => {
        if (selectedState === null) {
            this.setState({
                selectedState: null,
                selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null,
                allPrerakData: []
            });
        } else {
            this.setState({
                selectedState, selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null
            });
            this.getAllDistricts(selectedState);
        }
        this.setState({ allDistrictsData: [], allTehsilsData: [], allVillagesData: [] });
    };

    handleDistrictChange = selectedDistrict => {
        if (selectedDistrict === null) {
            this.setState({
                selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null,
            });
        } else {
            this.setState({
                selectedDistrict, selectedTehsil: null,
                selectedVillage: null
            });
            this.getAllTehsils(selectedDistrict);
        }
        this.setState({ allTehsilsData: [], allVillagesData: [] });
    };

    handleTehsilChange = selectedTehsil => {
        if (selectedTehsil === null) {
            this.setState({
                selectedTehsil: null,
                selectedVillage: null,
            });
        } else {
            this.setState({ selectedTehsil, selectedVillage: null });
            this.getAllVillageById(selectedTehsil);
        }
        this.setState({ allVillagesData: [] });
    };

    handleVillageChange = selectedVillage => {
        if (selectedVillage === null) {
            this.setState({
                selectedVillage: null,
            });
        } else {
            this.setState({ selectedVillage });
        }
    };

    handlePrerakChange = selectedPrerak => {
        this.setState({ selectedPrerak });
    };

    handleCropChange = selectedCrop => {
        this.setState({ selectedCrop });
    };

    handleCropGroupChange = selectedCropGroup => {

        this.setState({ selectedCropGroup });
        if (selectedCropGroup) {
            this.getAllActiveCrop(selectedCropGroup.value);
        } else {
            this.setState({ allCropData: [], selectedCrop: null })
        }
    };

    onFocus = (event, fieldName) => {
        event.preventDefault();
        if (fieldName === "fromDate") {
            this.setState({
                type1: 'date',
            });
        } else {
            this.setState({
                type2: 'date',
            });
        }
    }

    onBlur = (event, fieldName) => {
        event.preventDefault();
        let fields = this.state.fields;
        fields[fieldName] = moment(this._getFieldValue(fieldName, ""), "YYYY-MM-DD").format("DD-MM-YYYY");
        this.setState({
            type1: 'text',
            type2: 'text',
            fields
        });
    }

    addReport = async () => {
        const toDate = moment(this._getFieldValue("toDate", ""), "DD-MM-YYYY").format("YYYY-MM-DD");
        const fromDate = moment(this._getFieldValue("fromDate", ""), "DD-MM-YYYY").format("YYYY-MM-DD");

        if (fromDate === 'Invalid date' || toDate === 'Invalid date') {
            alert("Please Select From and To Date");
            return;
        }

        this.setState({ isLoading: true });
        const { selectedCrop, selectedCropGroup, selectedPrerak, selectedState, selectedTehsil, selectedVillage, selectedDistrict } = this.state;
        const mobile = this._getFieldValue("mobile", "");

        const requestParams = {
            page: 1,
            perPage: 1000,
            searchKey: "",
            sortBy: "state_name",
            sortOrder: "DESC",
            from_date: fromDate,
            to_date: toDate,
            state_id: selectedState ? [selectedState.value] : [],
            village_id: selectedVillage ? [selectedVillage.value] : [],
            district_id: selectedDistrict ? [selectedDistrict.value] : [],
            tehsil_id: selectedTehsil ? [selectedTehsil.value] : [],
            phone: mobile,
            prerak_id: selectedPrerak ? [selectedPrerak.value] : [],
            crop_id: selectedCrop ? selectedCrop.value : 0,
            crop_group_id: selectedCropGroup ? selectedCropGroup.value : 0,
        }
        var body = JSON.stringify({
            request: requestParams,
            type: ReportType.EXPORT_KRISHAK_REPORT
        });

        try {
            ApiServices.addReport(body).then(async response => {

                var status = await response.success;
                Utilities.LogPrint("userReport", response);
                if (status) {
                    let data = response.data;
                    if (data !== null) {
                        this.getReports();
                    }
                } else {
                    if (response.message === COMMON.TOKEN_EXPIRED) {
                        Utilities.tokenExpiredRedirectToLogin();
                    }
                }
            }).catch(error => {
                this.setState({ isLoading: false });
            });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const fromDate = this._getFieldValue("fromDate", "");
        const toDate = this._getFieldValue("toDate", "");
        const mobile = this._getFieldValue("mobile", "");
        const { isSyncLoading, tableName } = this.state;
        const { isLoading, allCropData, allCropGroupData, selectedCrop, selectedCropGroup, allPrerakData, allStatesData, allDistrictsData, allTehsilsData, allVillagesData, selectedState, selectedPrerak, selectedDistrict, selectedTehsil, selectedVillage } = this.state;

        return (
            <div>
                <Header selectedTab={HeaderTypes.REPORTS} handleSyncLoading={this.handleSyncLoading} />
                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-md-6">
                            <h1>{REPORTS_SCREEN.KRISHAK_REPORT}</h1>
                        </div>
                        <div className="col-lg-6 d-md-flex back-btn d-none">
                            <button className="btn btn-secondary" onClick={this.addReport}><i className="customic print" />{COMMON.GENERATE_REPORT}</button>
                            {/* <button className="btn btn-secondary" onClick={this.handleDataPrint}><i className="customic print" />Generate Report</button> */}
                        </div>
                    </div>
                    {/* <form> */}
                    <form action="">
                        <div className="row mt-4">
                            <div className="col-md-3 col-12">
                                <div className="form-group input-date">
                                    <input type={this.state.type1} min={moment().subtract(74, 'years').format("YYYY-MM-DD")} max={moment().format("YYYY-MM-DD")} id="fromDate" className="form-control mb-0" onFocus={(e) => this.onFocus(e, "fromDate")} onBlur={(e) => this.onBlur(e, "fromDate")} onChange={this._handleValueChange.bind(this, "fromDate")} placeholder={COMMON.FROM_DATE} value={fromDate} />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group input-date">
                                    <input type={this.state.type2} min={moment().subtract(74, 'years').format("YYYY-MM-DD")} max={moment().format("YYYY-MM-DD")} id="toDate" className="form-control mb-0" onFocus={(e) => this.onFocus(e, "toDate")} onBlur={(e) => this.onBlur(e, "toDate")} onChange={this._handleValueChange.bind(this, "toDate")} placeholder={COMMON.TO_DATE} value={toDate} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedState}
                                        onChange={this.handleStateChange}
                                        options={allStatesData}
                                        placeholder={COMMON.STATE}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedDistrict}
                                        onChange={this.handleDistrictChange}
                                        options={allDistrictsData}
                                        placeholder={COMMON.DISTRICT}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedTehsil}
                                        onChange={this.handleTehsilChange}
                                        options={allTehsilsData}
                                        placeholder={COMMON.TEHSIL}
                                        isClearable={true}
                                    />

                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedVillage}
                                        onChange={this.handleVillageChange}
                                        options={allVillagesData}
                                        placeholder={COMMON.VILLAGE}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedPrerak}
                                        onChange={this.handlePrerakChange}
                                        options={allPrerakData}
                                        placeholder={COMMON.PRERAK}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <input type="tel" name="telephone" maxLength="10" className="form-control" placeholder={COMMON.MOBILE_NUMBER_OF_FARMER} onChange={this._handleValueChange.bind(this, "mobile")} value={mobile} />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedCropGroup}
                                        onChange={this.handleCropGroupChange}
                                        options={allCropGroupData}
                                        placeholder={COMMON.SELECT_CROP_GROUP}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedCrop}
                                        onChange={this.handleCropChange}
                                        options={allCropData}
                                        placeholder={COMMON.SELECT_CROP}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>

                    <table
                        id="krishakReport"
                        ref={(el) => (this.el = el)}
                        className="display table table-responsive table-striped table-bordered mobile-number"
                        style={{ display: "table" }}>
                    </table>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                {isLoading ? <Loader /> : null}
                <DesktopFooter />
            </div>
        )
    }
}

export default withRouter(KrishakReport)